import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PlayCircle, FileText, ArrowRight } from "lucide-react";
import { api, API, errMsg } from "../lib/api";
import { Logo } from "../components/Brand";

const mediaUrl = (path) => `${API}/media/${path}`;

export default function Watch() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [mi, setMi] = useState(0);
  const [pi, setPi] = useState(0);
  useEffect(() => { api.get(`/share/${token}`).then((r) => setData(r.data)).catch((e) => setError(errMsg(e))); }, [token]);
  useEffect(() => { if (data) document.title = `${data.course.title} - Dexterity Consult`; }, [data]);

  const header = (
    <header className="bg-[#250E31] px-5 sm:px-10 py-4 flex items-center justify-between">
      <Link to="/"><Logo light /></Link>
      {data && <Link to={`/app/academy?enrol=${data.course.slug}`} className="dx-btn-gold text-sm" data-testid="watch-enrol-btn">Enrol <ArrowRight className="w-4 h-4" /></Link>}
    </header>
  );
  if (error) return <div className="min-h-screen bg-[#FAF8FC]">{header}<div className="dx-card max-w-lg mx-auto mt-16 p-8 text-center" data-testid="watch-error">{error}</div></div>;
  if (!data) return <div className="min-h-screen bg-[#FAF8FC]">{header}</div>;
  const mod = data.modules[mi];
  const parts = mod?.parts || [];
  const pick = (i) => { setMi(i); setPi(0); };

  return (
    <div className="min-h-screen bg-[#FAF8FC]" data-testid="watch-page">
      {header}
      <main className="max-w-6xl mx-auto px-4 sm:px-8 py-8">
        <div className="dx-eyebrow">{data.course.code} · {data.course.duration}</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#250E31] mt-2" data-testid="watch-title">{data.course.title}</h1>
        <div className="grid lg:grid-cols-12 gap-5 mt-6">
          <aside className="lg:col-span-4 dx-card p-3 h-fit">
            {data.modules.map((m, i) => (
              <button key={m.id} onClick={() => pick(i)} data-testid={`watch-module-${m.id}`}
                className={`w-full text-left rounded-md px-3 py-2.5 text-sm ${i === mi ? "bg-[#F4EEF7] font-semibold" : "hover:bg-[#FAF8FC]"}`}>
                {i + 1}. {m.title}<div className="text-xs text-[#8a7a92] font-normal">{m.parts.length ? `${m.parts.length} video parts` : "Videos coming soon"}</div>
              </button>
            ))}
          </aside>
          <section className="lg:col-span-8 dx-card p-5 sm:p-7">
            <h2 className="font-display text-xl font-bold text-[#250E31]">{mod?.title}</h2>
            {parts.length ? (
              <>
                <video key={parts[pi].id} src={mediaUrl(parts[pi].path)} controls preload="metadata" playsInline className="w-full aspect-video bg-black rounded-md mt-4"
                  onEnded={() => pi < parts.length - 1 && setPi(pi + 1)} data-testid="watch-video" />
                <div className="flex flex-wrap gap-2 mt-3">
                  {parts.map((p, i) => (
                    <button key={p.id} onClick={() => setPi(i)} data-testid={`watch-part-${i}`}
                      className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-semibold border ${i === pi ? "bg-[#5B2A6E] text-white border-[#5B2A6E]" : "text-[#5B2A6E] hover:bg-[#F4EEF7]"}`}>
                      <PlayCircle className="w-3.5 h-3.5" />{p.title}
                    </button>
                  ))}
                </div>
              </>
            ) : <p className="text-sm text-[#6b5a73] mt-4" data-testid="watch-no-videos">Videos for this session are coming soon.</p>}
            {mod?.slides && <a href={mediaUrl(mod.slides.path)} target="_blank" rel="noreferrer" className="dx-btn-ghost mt-4" data-testid="watch-slides"><FileText className="w-4 h-4" />Session slides (PDF)</a>}
          </section>
        </div>
      </main>
    </div>
  );
}
